import React, { Component } from 'react';

import { Form, TreeSelect } from 'antd';

import service from './../../services';
const FormItem = Form.Item;

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.value] = d.label;
    });

    return maps;
}

class Name extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: undefined,
            data: [],
            maps: {},
            keys: ['1']
        };
    }

    componentDidMount() {
        this.querySearch(this.props.type ?  {type: this.props.type} : {});
    }

    querySearch(params) {
        service.employee.querySearchByName(params)
        .then((data) => {
            return data.map(item => {
                return {
                    value: item.value,
                    key: item.value,
                    label: item.label
                }
            }).slice(0,50);
        }).then(employeeData => {
            this.setState({
                value: this.props.value ? this.props.value : []
            });
            const maps = codes(employeeData);
            this.setState({
                data: employeeData,
                maps:maps
            })
        });
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value ? nextProps.value : [],
            });
        }
    }

    handleChange(value) {
        this.setState({
            value: value
        });
        let employeeNames = [];
        for(let i = 0; i < value.length; i++) {
            employeeNames.push(this.state.maps[value[i]])
        }
        if(this.props.handleChange) {
            this.props.handleChange({
                employeeIdList: value,
                employeeNameList: employeeNames
            });
        }
    }

    onSearch(value) {
    }

    render() {
        const {label, style , notAllowClear, disabled} = this.props;
        const { data, value } = this.state;
        return (
            <FormItem label="指导教师">
                {
                   (
                        <TreeSelect
                            disabled={disabled}
                            multiple
                            allowClear={notAllowClear === true ? false : true}
                            value={value}
                            treeData={data}
                            dropdownClassName="org-tree-select"
                            placeholder='请选择指导教师'
                            treeDefaultExpandedKeys={this.state.keys}
                            style= {style || {width: 240}}
                            onSearch={this.onSearch.bind(this)}
                            onChange={(value) => {
                                if(value) {
                                    this.handleChange(value);
                                } else {
                                    this.handleChange(value);
                                }
                            }}
                        />
                    )
                }
            </FormItem>
        );
    }
}

export default Name;